







import { defineComponent } from '@vue/composition-api';
import Footer from '@/components/Footer/Footer.vue';

export default defineComponent({
  components: {
    Footer,
  },
});
